import { useAuth as libUseAuth } from "@marekl/adminer";
import type { User } from "./queries";

export function useAuth() {
  return libUseAuth<User>();
}
